import { defineStore } from 'pinia'

import { StoreId } from '@/store'
import { DEFAULT_STATE_MAP } from '@/store/addressSystem/address-system.constants'
import { AddressSystemMap } from '@/store/addressSystem/address-system.types'
import { useCityStore } from '@/store/city/city'

import { AreasData } from '@/api/modules/delivery/types'
import { Success } from '@/api/results'

import type { DragCoordinates } from '@/api/modules/delivery/types'

export const useAddressSystemMapStore = defineStore(
  StoreId.ADDRESS_SYSTEM_MAP,
  {
    state: (): AddressSystemMap => DEFAULT_STATE_MAP,
    actions: {
      setAreasData(areasData: AreasData | null) {
        if (!areasData) return

        this.points = areasData.points
        this.areas = areasData.areas
      },

      async updateAreas(bounds: DragCoordinates) {
        this.toggleLoadingAreas()

        // Получаем полигоны в области bounds карты
        await this.changeAreasByCoords(bounds)

        this.toggleLoadingAreas()
      },

      async changeAreasByCoords(coords: DragCoordinates) {
        const { cityInfo } = useCityStore()
        const { $apiService } = useNuxtApp()

        if (!cityInfo.domain_prefix) return

        const result = await $apiService.delivery.fetchAreasByCoordinates(
          coords,
          {
            domain_prefix: cityInfo.domain_prefix,
          },
        )

        if (!(result instanceof Success)) return

        this.setAreasData(result.data)
      },

      toggleLoadingAreas() {
        this.isLoadingAreas = !this.isLoadingAreas
      },

      changeVisibleClarifyShow(value: boolean) {
        this.isShowClarifyAddress = value
      },
    },
    getters: {
      // Точки ресторанов "Самовывоз"
      pickupPoints: ({ points }) => {
        if (points.length === 0) return points

        return points.filter((point) => point.pickup)
      },

      // Точки ресторанов "В ресторане"
      hallPoints: ({ points }) => {
        if (points.length === 0) return points

        return points.filter((point) => point.hall)
      },
    },
  },
)
